// extracted by mini-css-extract-plugin
export default {"title":"BannerTitle_title__9y17D","title2":"BannerTitle_title2__I+IlM"};